import Api from "@/config/Api";

export default {
  // ── Sequences ──
  getSequences(params = {}) {
    return Api().get("/reminders/sequences", { params });
  },
  getSequence(id) {
    return Api().get(`/reminders/sequences/${id}`);
  },
  createSequence(data) {
    return Api().post("/reminders/sequences", data);
  },
  updateSequence(id, data) {
    return Api().put(`/reminders/sequences/${id}`, data);
  },
  deleteSequence(id) {
    return Api().delete(`/reminders/sequences/${id}`);
  },

  // ── Steps ──
  createStep(sequenceId, data) {
    return Api().post(`/reminders/sequences/${sequenceId}/steps`, data);
  },
  updateStep(sequenceId, stepId, data) {
    return Api().put(
      `/reminders/sequences/${sequenceId}/steps/${stepId}`,
      data
    );
  },
  deleteStep(sequenceId, stepId) {
    return Api().delete(`/reminders/sequences/${sequenceId}/steps/${stepId}`);
  },

  // ── Assign / Pause / Resume ──
  assign(data) {
    return Api().post("/reminders/assign", data);
  },
  pause(data) {
    return Api().post("/reminders/pause", data);
  },
  resume(data) {
    return Api().post("/reminders/resume", data);
  },

  // ── Logs ──
  getLogs(params = {}) {
    return Api().get("/reminders/logs", { params });
  },
  getLogsForDocument(documentType, documentId) {
    return Api().get(`/reminders/logs/${documentType}/${documentId}`);
  },

  // ── Plantilla de WhatsApp para cobros (facturas) ──
  // Plantillas aprobadas del WhatsApp del módulo de marketing (Back-mkt)
  getCollectionWhatsappTemplates() {
    return Api().get("/reminders/collection-whatsapp-templates");
  },
  getCollectionWhatsappTemplate() {
    return Api().get("/reminders/collection-whatsapp-template");
  },
  setCollectionWhatsappTemplate(data) {
    return Api().post("/reminders/collection-whatsapp-template", data);
  }
};
